// extracted by mini-css-extract-plugin
export var phone = "_1s-0";
export var phoneDragging = "_1s-1";